/** Raised when something didn't finish in time. */
export class TimeoutError extends Error {}

/** A promise that gives up after `ms`, so nothing at start-up can wait forever. */
export function withTimeout<T>(work: Promise<T>, ms: number, message: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const t = setTimeout(() => reject(new TimeoutError(message)), ms);
    work.then(v => { clearTimeout(t); resolve(v); }, e => { clearTimeout(t); reject(e); });
  });
}
